export default function servicesService($http, RESOURCES) {
  var servicesUrl = '/services';

  function getServices(id) {
    return $http.get(RESOURCES.MERCHANT + '/' + id + servicesUrl);
  }

  function createService(id, data) {
    return $http.post(RESOURCES.MERCHANT + '/' + id + servicesUrl, data);
  }

  function getService(merchantId, serviceId) {
    return $http.get(RESOURCES.MERCHANT + '/' + merchantId + servicesUrl + '/' + serviceId);
  }

  function updateService(merchantId, serviceId, data) {
    return $http.put(RESOURCES.MERCHANT + '/' + merchantId + servicesUrl + '/' + serviceId, data);
  }

  function deleteService(merchantId, serviceId) {
    return $http.delete(RESOURCES.MERCHANT + '/' + merchantId + servicesUrl + '/' + serviceId);
  }

  function updateSortOrder(merchantId, serviceId, index) {
    return $http.put(RESOURCES.MERCHANT + '/' + merchantId + servicesUrl + '/' + serviceId + '/sort_order', { index: index });
  }

  function updateServiceStatuses(merchantId, categoryId, services) {
    return $http.put(RESOURCES.MERCHANT + '/' + merchantId + servicesUrl + '/' + categoryId + '/statuses', { serviceItemDtos: services });
  }

  return {
    getService: getService,
    createService: createService,
    getServices: getServices,
    updateService: updateService,
    deleteService: deleteService,
    updateSortOrder: updateSortOrder,
    updateServiceStatuses: updateServiceStatuses,
  };
}



// WEBPACK FOOTER //
// ./src/app/merchants/services/services.service.js